import { render, staticRenderFns } from "./BusinessInformationComponent.vue?vue&type=template&id=cb788e88"
import script from "./BusinessInformationComponent.vue?vue&type=script&lang=ts"
export * from "./BusinessInformationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports